import { motion } from "framer-motion";
import { Zap, Globe2, ShieldCheck, Clapperboard, Headphones, MonitorPlay } from "lucide-react";

const items = [
  { icon: Globe2, title: "Disponible en todo el mundo", desc: "Disfruta tu contenido favorito sin importar tu país. Servidores optimizados para baja latencia global." },
  { icon: Zap, title: "Sin cortes ni buffering", desc: "Infraestructura estable con 99.9% de uptime para una reproducción fluida en HD y 4K." },
  { icon: Clapperboard, title: "Catálogo gigante", desc: "Más de 22,000 películas y 3,000 series, actualizadas constantemente con los últimos estrenos." },
  { icon: MonitorPlay, title: "Más de 13,000 canales", desc: "Deportes, noticias, películas, infantiles y canales internacionales en un solo lugar." },
  { icon: ShieldCheck, title: "Conexión segura", desc: "Tu acceso es privado y protegido. Credenciales personales para tu cuenta." },
  { icon: Headphones, title: "Soporte real", desc: "Te acompañamos en la instalación y resolvemos tus dudas por WhatsApp o Telegram." },
];

const cardVar = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

export const Features = () => {
  return (
    <section id="beneficios" data-testid="features-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Manifiesto — Por qué elegirnos</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            Una experiencia premium, pensada para ti
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              data-testid="feature-card"
              variants={cardVar}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="group relative"
            >
              <div className="flex items-baseline gap-4 border-t border-bp-border pt-6 transition-colors duration-300 group-hover:border-bp-primary/60">
                <span className="font-heading text-3xl lg:text-4xl font-semibold text-bp-primary/25 tabular-nums transition-colors duration-300 group-hover:text-bp-primary/70">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1">
                  <div className="mb-4 grid place-items-center w-11 h-11 rounded-xl bg-bp-primary/10 text-bp-primary transition-all duration-300 group-hover:bg-bp-primary group-hover:text-white group-hover:-translate-y-1">
                    <it.icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-heading text-xl font-medium text-white">{it.title}</h3>
                  <p className="mt-2 text-[#A3A3A3] text-sm leading-relaxed">{it.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
